import { modalLimitDataContentState } from 'Pages/Campaign/recoil/state/modals'

import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

const ModalLimitDataContent = () => {
  const intl = useIntl()
  const [{ show, replaceValue }, setShow] = useRecoilState(
    modalLimitDataContentState
  )

  const handleClick = () => {
    setShow((prev) => ({ ...prev, show: false, replaceValue: 0 }))
  }

  return (
    <Modal
      data-mu-test='modal__limit-data-content'
      show={show}
      showClose
      onClose={handleClick}
      closeOnOverlayClick
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.ContentsCampaignWizard.ModalLimitDataTitle'
        })}
      />
      <ModalBody>
        {intl.formatMessage(
          {
            id: 'Load.ContentsCampaignWizard.ModalLimitDataDescr'
          },
          {
            N: replaceValue
          }
        )}
      </ModalBody>
      <ModalFoot>
        <Button variant={BUTTON_VARIANT_PRIMARY} onClick={handleClick}>
          {intl.formatMessage({ id: 'Load.ModalConfermeDelete.Ok' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalLimitDataContent
